import { c as _c } from "react/compiler-runtime";
import { EditorView } from '@codemirror/view';
import { useEffect, useState } from 'react';
export const useScrollPastEnd = containerRef => {
  const $ = _c(3);
  const [extension, setExtension] = useState(_temp);
  let t0;
  let t1;
  if ($[0] !== containerRef) {
    t0 = () => {
      if (!containerRef?.current) {
        return;
      }
      const update = () => {
        const height = containerRef.current?.clientHeight ?? 0;
        const padding = Math.max(0, height - 26);
        setExtension(EditorView.theme({
          ".cm-scroller": {
            paddingBottom: `${padding}px`
          }
        }));
      };
      update();
      let ro = null;
      if (typeof ResizeObserver !== "undefined") {
        ro = new ResizeObserver(update);
        ro.observe(containerRef.current as Element);
      }
      window.addEventListener("resize", update);
      return () => {
        if (ro) {
          ro.disconnect();
        }
        window.removeEventListener("resize", update);
      };
    };
    t1 = [containerRef];
    $[0] = containerRef;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  return extension;
};
function _temp() {
  return EditorView.theme({
    ".cm-scroller": {
      paddingBottom: "0px"
    }
  });
}